export type CardAssignmentDTOType =
  (typeof CardAssignmentDTOType)[keyof typeof CardAssignmentDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAssignmentDTOType = {
  travelcard: 'travelcard',
  walletcard: 'walletcard',
  schoolcard: 'schoolcard',
} as const;
